// extracted by mini-css-extract-plugin
module.exports = {"SubCategories":"style_SubCategories__1DAai","SubCategory":"style_SubCategory__ea0A0"};